<template>
  <div
      v-if="(type === 'li' && realVisible && !select)"
      ref="optionRef"
      :class="liClass"
      tabindex="0"
      @click="handleClick"
      v-on:keyup.enter="handleClick"
      @keydown.tab="handleTabPress($event)"
  >
    {{ text }}
  </div>
  <div
      v-else-if="(type === 'root' && !select)"
      :style="ulClass === 'hide' ? 'display: none;' : ''"
      class="c-multi-select-options"
  >
    <slot></slot>
  </div>
  <div v-else-if="(type === 'c-label' && !select)"
       class="c-multi-select-optgroup-label"
  >
    {{ label }}
  </div>
  <div
      v-else-if="(type === 'ul' && !select)"
      class="c-multi-select-optgroup"
  >
    <slot></slot>
  </div>

  <option
      v-else-if="(type === 'li' && realVisible && select)"
      :selected="selected ? 'selected' : null"
      :value="value"
      @click="$emit('selectitem', {value: value, text: text})"
  >
    {{ text }}
  </option>
  <select v-else-if="(type === 'root' && select)"
          :form="form"
          :name="name"
          class="c-multi-select"
          multiple
          style="display: none;"
          tabindex="-1"
  >
    <slot></slot>
  </select>
  <optgroup
      v-else-if="(type === 'ul' && select)"
      :label="label"
  >
    <slot></slot>
  </optgroup>
</template>

<script>

const props = {
  type: String,  //type of element
  text: String,   //text
  eltype: String,  // 'div' | 'select'
  value: String | Number,  //value
  visible: Boolean,  //visible
  label: String,     //label
  selected: Boolean, // element is selected
  ulClass: String,
  name: String,
  form: String,
}


export default {
  name: 'CMultiSelectElement',
  props,
  data: function () {
    return {
      select: false,
      realVisible: true,
      rootClass: '',
    }
  },
  computed: {
    liClass: function () {
      return {
        'c-multi-select-option': true,
        'c-multi-selected': this.selected
      }
    }
  },
  methods: {
    emptyGroup: function (el) {
      let result = false
      if (el.childElementCount === 1) {
        result = true
      }
      return result
    },
    lastGroup: function (el) {
      let node = el
      let result = false
      for (; ;) {
        node = node.parentElement
        if (typeof node.nextElementSibling != 'undefined' && node.nextElementSibling != null) {
          result = false
          break
        } else {
          if (node.classList.contains('c-multi-select-options')) {
            result = true
            break
          }
        }
      }
      return result
    },
    handleTabPress: function (e) {
      if (!e.shiftKey) {
        let node = this.$refs.optionRef
        if (typeof node.nextElementSibling == 'undefined' || node.nextElementSibling == null) {
          if (node.parentElement.classList.contains('c-multi-select-optgroup')) {
            if (this.lastGroup(node)) {
              this.$emit('closeselect')
            }
          } else {
            this.$emit('closeselect')
          }
        } else {
          if (node.nextElementSibling.className === 'c-multi-select-optgroup' && this.emptyGroup(node.nextElementSibling)) {
            this.$emit('closeselect')
          }
        }
      }
    },
    handleClick: function (/*event, args*/) {
      this.$emit('selectitem', {value: this.value, text: this.text}, this.$el)
    }
  },
  watch: {
    visible: function (after) {
      this.realVisible = after !== false;
    },
  },
  mounted: function () {
    if (typeof this.eltype != 'undefined' && this.eltype === 'select') {
      this.select = true
    }
    if (this.visible === false) {
      this.realVisible = false
    }
  },
}

</script>
